class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '.header',
			secondaryMenu: '#menu-bottom'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		let $secondaryMenu = this.$scope.find(this.config.secondaryMenu);
		if ($secondaryMenu.length > 0) {
			this.bsCollapse = new bootstrap.Collapse(this.config.secondaryMenu, {
				toggle: false
			});
		}

		this.headerScroll();
		this.initEventListeners();

		setTimeout(() => {
			this.$scope.removeClass('no-transition');
		}, 400);
	}

	initEventListeners() {
		$(window).on("scroll", () => {
			this.headerScroll();
		});
	}

	headerScroll() {
		let top = window.scrollY;
		if (top > 100) {
			this.$scope.addClass('header-scroll');
			if (this.bsCollapse) {
				this.bsCollapse.show();
			}
		} else {
			this.$scope.removeClass('header-scroll');
			if (this.bsCollapse) {
				this.bsCollapse.hide();
			}
		}
	}
}

export default new Header;
